'use strict';
module.exports = {
  RU: {
    zipPrefix: ['29']
  },
  UA: {
    zipPrefix: ['95', '96', '97', '98']
  }
};
